import { useState } from "react";
import { Dropdown, DropdownItem, DropdownToggle } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { SplitButtonDropdownProp } from "../../../../Type/UiKits";
import { Href } from "../../../../Constant";

const SplitButtonDropdown = ({ item }: SplitButtonDropdownProp) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <div className="btn-group">
      <Btn outline color={item.btnColor} type="button">{item.btnText}</Btn>
      <Dropdown className="separated-btn" isOpen={open} toggle={toggle}>
        <DropdownToggle color={item.btnColor}><i className="icofont icofont-arrow-down"></i></DropdownToggle>
        <div className="dropdown-content">
          {item.items.map((itm, index) => (
            <DropdownItem href={Href} key={index}>{itm.item}</DropdownItem>
          ))}
        </div>
      </Dropdown>
    </div>
  );
};

export default SplitButtonDropdown;
